module.exports = __webpack_public_path__ + "static/media/55_000086.0b8a8007.jpg";